module.exports = __webpack_public_path__ + "img/c02_unitcatapult_Normal_ua.dc8e1b73.webp";